import type { ExplosionLineStatus, ExplosionRunResult } from '@/services/explosions'

export type ExplosionRunGroupCounts = Record<ExplosionLineStatus, number>

export function computeExplosionRunGroupCounts(
  results: Array<Pick<ExplosionRunResult, 'line_status'>>,
): ExplosionRunGroupCounts {
  const counts: ExplosionRunGroupCounts = {
    OK: 0,
    NEEDS_MAPPING: 0,
    NO_BOM: 0,
    PACKAGING_OPTION_NOT_DEFINED: 0,
  }
  for (const r of results) {
    counts[r.line_status] += 1
  }
  return counts
}
